(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.BushelsController = (function(superClass) {
    extend(BushelsController, superClass);

    function BushelsController(scope, transitions, modal, bushelsService, q, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.bushelsService = bushelsService;
      this.q = q;
      this.http = http;
      this.parseYearBushelData = bind(this.parseYearBushelData, this);
      this.getData = bind(this.getData, this);
      this.save = bind(this.save, this);
      BushelsController.__super__.constructor.call(this, 'bushels', this.http);
      this.scope.fullpage = true;
      this.scope.title = 'Bushels';
      this.scope.tooltipContent = '<div> <p>This tool attempts to estimate the number of bushels MyFarms has increased the world food supply. It looks at the acreage of planting plans and records generated from an SPP, multiplied by the estimated bushels/acre increase from our recommendations. </p> <p>The last research we had from Burrus showed a 12.5 bushel per acre increase, which is the default. </p></div>';
      this.scope.bushelsIncrease = 12.5;
      this.getData();
      this.scope.updateGraph = (function(_this) {
        return function() {
          return _this.getData();
        };
      })(this);
    }

    BushelsController.prototype.save = function() {
      return this.getData();
    };

    BushelsController.prototype.getData = function() {
      return this.loadScopeData(this.bushelsService.getBushelsByYear(this.scope.bushelsIncrease), 'bushelsByYear').then((function(_this) {
        return function() {
          return _this.parseYearBushelData();
        };
      })(this));
    };

    BushelsController.prototype.parseYearBushelData = function() {
      var dataobject;
      this.scope.years = (function() {
        var i, len, ref, results;
        ref = this.scope.bushelsByYear.bushelsYearPlan;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          dataobject = ref[i];
          results.push(dataobject.year);
        }
        return results;
      }).call(this);
      this.scope.bushels = [
        (function() {
          var i, len, ref, results;
          ref = this.scope.bushelsByYear.bushelsYearPlan;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            dataobject = ref[i];
            results.push(parseFloat(dataobject.bushels));
          }
          return results;
        }).call(this), (function() {
          var i, len, ref, results;
          ref = this.scope.bushelsByYear.bushelsYearActual;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            dataobject = ref[i];
            results.push(parseFloat(dataobject.bushels));
          }
          return results;
        }).call(this)
      ];
      return this.scope.series = ['Plan Bushels Increased (millions)', 'Record Bushels Increased (millions)'];
    };

    return BushelsController;

  })(AccessController);

}).call(this);
